var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offline)?_c('div',{staticClass:"offline-message"},[_c('i',{staticClass:"far fa-dizzy"}),_c('h1',[_vm._v(" You're offline friend. "),_c('span',{on:{"click":_vm.checkOffline}},[_c('i',{staticClass:"fas fa-redo-alt"})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }